import { DateBox, Switch, TagBox } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import React from 'react';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import useFormatMessage from '../../../utils/useFormatMessage';

const SayimPopup = ({
    visible,
    onHiding,
    formData,
    setFormData,
    warehouses,
    zones,
    isZonesLoaded,
    handleWarehouseChange,
    handleSubmit,
    mountedRef,
    isSubmitting
}) => {
    const { t } = useFormatMessage();

    if (!visible) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const getAllStatusOptions = () => [
        { id: "CREATED", text: "Sayım Girişi Yapıldı" },
        { id: "STARTED", text: "Sayım Başlatıldı" },
        { id: "COMPLETED", text: "Sayım Tamamlandı" },
        { id: "CANCELLED", text: "Sayım İptal Edildi" },
    ];

    const getAvailableStatusOptions = (currentStatus) => {
        const allOptions = getAllStatusOptions();

        // Eğer sayım başlatılmışsa (STARTED), CREATED seçeneğini gösterme
        if (currentStatus === "STARTED") {
            return allOptions.filter(option => option.id !== "CREATED");
        }

        // Eğer sayım tamamlanmış veya iptal edilmişse, hiçbir değişiklik yapılamaz
        if (currentStatus === "COMPLETED" || currentStatus === "CANCELLED") {
            return allOptions.filter(option => option.id === currentStatus);
        }

        // Diğer durumlar için tüm seçenekleri göster
        return allOptions;
    };

    const renderPopupContent = () => {
        return (
            <Form className="p-3">
                <Row>
                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3' for="count_code">{t("Sayım Kodu")}</Label>
                            <Input
                                className='col-md-9'
                                id="count_code"
                                name="count_code"
                                placeholder='Otomatik Sayım Kodu'
                                value={formData.count_code}
                                onChange={handleInputChange}
                                disabled
                            />
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3'>{t("Depo")} <span className="text-danger">*</span></Label>
                            <SelectBox
                                className='col-md-9'
                                dataSource={warehouses}
                                displayExpr="warehouse_name"
                                valueExpr="id"
                                placeholder={t("Depo seçiniz...")}
                                disabled={formData.count_code === "" ? false :
                                    formData.status === "COMPLETED" || formData.status === "CANCELLED" || formData.id !== null || formData.status === "CREATED"}
                                value={formData.warehouse_id}
                                onValueChanged={(e) => {
                                    // Sadece warehouse gerçekten değiştiğinde handleWarehouseChange'i çağır
                                    if (e.value !== formData.warehouse_id) {
                                        handleWarehouseChange(e);
                                    }
                                }}
                                width="100%"
                                validationRules={[{ type: "required", message: t("Depo seçimi zorunludur") }]}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3'>{t("Bölge")} <span className="text-danger">*</span></Label>
                            <TagBox
                                key={`zone-tagbox-${formData.id || 'new'}-${zones.length}-${isZonesLoaded}`}
                                className='col-md-9'
                                dataSource={zones || []}
                                displayExpr="zone_name"
                                valueExpr="id"
                                placeholder={t("Bölge seçiniz...")}
                                disabled={
                                    zones?.length === 0 ? true :
                                        formData.count_code === "" ? false :
                                            formData.status === "COMPLETED" || formData.status === "CANCELLED" || formData.id !== null || formData.status === "CREATED"}
                                value={Array.isArray(formData.zone_id) ? formData.zone_id : []}
                                onValueChanged={(e) => {
                                    if (mountedRef.current) {
                                        setFormData(prev => ({
                                            ...prev,
                                            zone_id: Array.isArray(e.value) ? e.value : []
                                        }));
                                    }
                                }}
                                width="100%"
                                applyValueMode="useButtons"
                                searchEnabled={true}
                                showClearButton={true}
                                selectAllMode="allPages"
                                showSelectionControls={true}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3'>{t("Adresli Sayım")}</Label>
                            <Switch
                                width={"30%"}
                                disabled={formData.status !== "CREATED"}
                                value={formData.is_address_based}
                                onValueChanged={(e) => setFormData(prev => ({ ...prev, is_address_based: e.value }))}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3' for="start_date">{t("Başlangıç Tarihi")} <span className="text-danger">*</span></Label>
                            <DateBox
                                className='col-md-9'
                                id="start_date"
                                disabled={formData.status === "COMPLETED" || formData.status === "CANCELLED"}
                                displayFormat={"dd/MM/yyyy"}
                                value={formData.start_date || new Date()}
                                onValueChanged={(e) => setFormData(prev => ({ ...prev, start_date: e.value }))}
                                width="100%"
                                validationRules={[{ type: "required", message: t("Başlangıç tarihi zorunludur") }]}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col md={12}>
                        <FormGroup className='d-flex align-items-center row'>
                            <Label className='col-md-3'>{t("Durum")} <span className="text-danger">*</span></Label>
                            <SelectBox
                                className='col-md-9'
                                dataSource={getAvailableStatusOptions(formData.status)}
                                displayExpr="text"
                                valueExpr="id"
                                placeholder={t("Durum seçiniz...")}
                                value={formData.status}
                                disabled={formData.id === null}
                                onValueChanged={(e) => { setFormData(prev => ({ ...prev, status: e.value })) }}
                                width="100%"
                                validationRules={[{ type: "required", message: t("Durum seçimi zorunludur") }]}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    };

    return (
        <Popup
            visible={visible}
            onHiding={onHiding}
            dragEnabled={false}
            closeOnOutsideClick={!isSubmitting}
            hideOnOutsideClick={!isSubmitting}
            showTitle={true}
            title={formData.id === null ? t("Sayım Girişi") : t("Sayım Düzenleme")}
            width={800}
            height={550}
            toolbarItems={[{
                location: 'after',
                widget: 'dxButton',
                toolbar: 'bottom',
                options: {
                    text: isSubmitting ? t('Kaydediliyor...') : t('Kaydet'),
                    onClick: handleSubmit,
                    disabled: isSubmitting,
                    icon: isSubmitting ? 'fa fa-spinner fa-spin' : undefined
                }
            }, {
                location: 'after',
                widget: 'dxButton',
                toolbar: 'bottom',
                cssClass: 'dx-popup-cancel-button-sayim',
                options: {
                    text: t('İptal'),
                    onClick: onHiding,
                    disabled: isSubmitting
                }
            }]}
        >
            {renderPopupContent()}
        </Popup>
    );
};

export default SayimPopup; 